/**
* Controller for the directive that allows tasks to be marked as claimed, rejected, or completed
* @author Brendan Magee
*/

function TaskQuickButtonsController(
  $scope,
  toastWrapperService,
  analyticsService
) {
  $scope.update = (newStatus) => {
    const update = {
      assignedGroup: $scope.task.latestEvent.assignedGroup,
      assignedUser: $scope.username,
      priority: $scope.task.latestEvent.priority,
      status: newStatus,
      deadline: $scope.task.latestEvent.deadline,
      customFields: $scope.task.latestEvent.customFields
    };

    $scope.task.update(update)
      .then((data) => {
        Object.assign($scope.task, data, { story: $scope.task.story });

        $scope.task.updated = true;

        toastWrapperService.taskUpdate(newStatus);

        analyticsService.trackEvent('Task management (task quick buttons)', 'Updated task status');
      }, (response) => {
        const errorMessage = response.data && response.data.error ? response.data.error : response;

        toastWrapperService.createToast(errorMessage, 'danger');
      });
  };
}

const controllerArray = [
  '$scope',
  'toastWrapperService',
  'analyticsService',
  TaskQuickButtonsController
];

export default function (ngModule) {
  ngModule.controller('TaskQuickButtonsController', controllerArray);
}
